export default __webpack_public_path__ + "static/agile_process-d40edbf3847b37a73d488656c05cb21d.webp";